import {Injectable} from '@angular/core';
import {GtmEventEnum} from '../enums/GoogleEnums';
import {RoutesEnums} from '../enums/RoutesEnums';
import {ToolsService} from './tools.service';
import {Router} from '@angular/router';
import {GtmService} from './gtm.service';
import {DataLayerParamsPageViewGA4} from '../types/DataLayerParamsPageViewGA4';
import {SessionService} from './session.service';
import {DLPageTypeEnum} from '../enums/DataLayerEnums';
import {DataLayerPageViewTag} from '../types/DataLayerPageViewTag';

@Injectable()
export class PageViewsGa4ResolverService {
  private pageViewTriggersMap: Array<Function> = [];
  private previousUrlArray: string[];
  private previousUrl: string;

  constructor(
    private gtmService: GtmService,
    private tools: ToolsService,
    private router: Router,
    private session: SessionService,
  ) {
    this.createPageViewTriggersMap();
  }

  public trackPageView(customParams?: DataLayerParamsPageViewGA4): void {
    const url = this.router.url;
    if (url === this.previousUrl) {
      return;
    }
    const urlArray: string[] = url.split('/').splice(1);
    if (!this.tools.isNil(this.pageViewTriggersMap[urlArray[0]])) {
      this.pageViewTriggersMap[urlArray[0]](urlArray, url, customParams);
    } else {
      this.triggerPageView(url, customParams);
    }
    this.previousUrlArray = urlArray;
    this.previousUrl = url;
  }

  private createPageViewTriggersMap(): void {
    this.pageViewTriggersMap[RoutesEnums.CAREPROVIDER] = (
      urlArray: string[],
      url: string,
      customParams: DataLayerParamsPageViewGA4,
    ) => this.handleCareproviderRoute(urlArray, url, customParams);
  }

  private handleCareproviderRoute(urlArray: string[], url: string, customParams: DataLayerParamsPageViewGA4): void {
    if (
      this.tools.isNil(this.previousUrlArray) ||
      urlArray[0] !== this.previousUrlArray[0] ||
      urlArray[1] !== this.previousUrlArray[1]
    ) {
      this.triggerPageView(url, customParams);
    }
  }

  private triggerPageView(url: string, customParams?: DataLayerParamsPageViewGA4): void {
    if (this.tools.isNil(customParams)) {
      customParams = {
        pageTitle: '',
        pageType: DLPageTypeEnum.OTHER_PAGE,
      };
    }
    const dlFields: string[] = [
      'pageTitle',
      'pageType',
      'inferredCareProviderTypeAreaId',
      'inferredCategoryTypeId',
      'mainCareProviderTypeId',
      'careServiceId',
      'careServiceTypeId',
      'cpruId',
      'timeSlots',
      'isInitialBookingStep',
      'internalBookingFlowStep',
      'treatmentId',
      'adCampaignOwner',
      'TimeslotMatchExisted',
    ];
    dlFields.forEach((field) => {
      if (this.tools.isNil(customParams[field])) {
        customParams[field] = null;
      }
    });
    const gtmTag: DataLayerPageViewTag = {
      event: GtmEventEnum.VIRTUAL_PAGE_VIEW,
      pageUrl: url,
      SessionID: this.session.getSessionID(),
      ...customParams,
    };
    this.gtmService.pushTag(gtmTag);
  }
}
